define('models/TranslationModel',['underscore','ObjectModel','LocalStorage','sprintf', 'site_vars'],function (_,ObjectModel,LocalStorage,sprintf, site_vars) {
    //
    // Model Translation
    //
    var translateModel; // singleton ref
    var TranslationModelPrototype = {
        
        name:'TranslationModel',
        route:'apiTranslationModel',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            // singleton
            translateModel = this;
            //
            // t est un raccourci de translateModel.translate(value,context,parameters)
            // une fonction *globale* de traduction
            // attention au scope et à la vulnérabilité de cette fonction
            //
            window.t = t = translateModel.t = translateModel.translate;
        },
        translate:function(value,context,parameters){
            context = translateModel.get(context);
            function flag(f){
                return site_vars.debug ? f:''
            }
            if(_.isUndefined(context)) context = translateModel.get('default') || {};
            var translation = context[value];
            if(_.isUndefined(translation)) {
                translation = value;
            }

            if(_.isUndefined(parameters)) {
                return translation;
            }
            //
            switch(typeof parameters){
                case 'boolean' :
                case 'string' :
                case 'number' :
                    var string = parameters.toString();
                    parameters = new Array();
                    parameters.push(string); break;
            }
            //
            //
            try {
                var r = sprintf.vsprintf(translation, parameters);
            }catch(err){

                return translation;
            }
            return r;
        }
    };

    var TranslationModel = ObjectModel.extend(LocalStorage).extend(TranslationModelPrototype);

    return TranslationModel;
});
